export class Language {
    emphasis_large = 'font-size: 1.4em;\n' +
        'color: #0057a9;\n' +
        'display: inline-block;'
    arrEn = {
        'menu-top': 'Top',
        'menu-feature': 'Feature',
        'menu-price': 'Plans',
        'menu-price-2': 'Plan',
        'menu-Price': 'Price',
        'menu-environment': 'Environment',
        'menu-trial': 'Free Trial',
        'menu-campaign': 'Campaign',
        'menu-company': 'Company',
        'menu-support': 'Support',
        'menu-contact': 'Contact',
        'menu-faq': 'FAQ',
        'menu-tutorial': 'Tutorial',
        'menu-privacy-statement': 'Privacy Statement',
        'menu-specified': ' Act on Specified Commercial Transactions',
        'menu-specified-link': 'assets/img/document/specified_commercial_transactions_en.pdf',
        'content-company': 'Frontier Inc.',
        'title-application': 'Application Form for Free Trial',
        'title-feature': 'Features of',
        'title-goal': 'Goals of',
        'title-goal-stt': true,
        'title-contact': 'Contact Form',
        'title-forgot-password': 'Reset password form',
        'title-reset-password': 'Reset password',
        'title-view': 'View all videos',
        'button-next': 'Next',
        'button-back': 'Back',
        'button-apply': 'Apply',
        'message-heading': 'Aligner Orthodontics Support Software',
        'message-heading-sub': true,
        'message-heading-last': '1 month free trial.',
        goals: ['<span style="' + this.emphasis_large + '" >Better Treatment Results: &nbsp;</span>OrthoComm increases clients\' usage of aligners and acceleration devices with treatment slideshows, acceleration effect graphs, achievement graphs and other features.', '<span style="' + this.emphasis_large + '">Reduce Operation Costs: &nbsp;</span>Simple change of parameter leads to rescheduling of aligner count, update of mail scheduling and many graphs, while simple upload of an image creates 2 types of treatment slideshows.', '<span style="' + this.emphasis_large + '">Client Support: &nbsp;</span>  Periodical mails to notify aligner exchange to the client and smart phone apps increase the client\'s motivation during treatment.', '<span style="' + this.emphasis_large + '">Differentiate from Other Clinics: &nbsp;</span> Increasing satisfaction of clients differentiates your clinic from others.'],
        'feature-image-management-title': 'Image Management (Slideshow)',
        'feature-image-management-message': ['Simple upload of images creates 2 types of treatment slideshows.', 'Treatment slideshows encourage the client\'s motivation during treatment.'],
        'feature-aligner-management-title': 'Aligner Management',
        'feature-aligner-management-message': ['Simple change of parameter leads to rescheduling of aligner count.', 'Automatic email on the day of aligner exchange.', 'Aligner exchange schedule is shown to the client in a calendar format (in future).'],
        'feature-compliance-management-title': 'Compliance Management',
        'feature-compliance-management-message': ['Manage client\'s usage statistics of aligners and acceleration device (AcceleDent <sup>&reg;</sup> or OrthoPulse &trade; ).', 'The graph that shows the effect of acceleration device with the comparison of ideal usage / no usage of acceleration device and current exchange schedule of the client.'],
        'feature-mail-title': 'Mail',
        'feature-mail-message': ['Automatic email on the day of aligner exchange.', 'Movie transcoding technology to send Clincheck movie to a client.'],
        'feature-smart-phone-app-title': 'App for Client (in future).',
        'feature-smart-phone-app-message': ['The calendar and notifications remind the client of aligner exchange.', 'Treatment slideshows encourage client\'s motivation during treatment.', 'Show usage statistics of aligner and acceleration device.', 'Client is able to check and schedule the next appointment.'],
        'form-error-required': 'This field is required',
        'form-error-userid-exist': 'This User ID is already used.',
        'form-error-password-valid': 'Please register only half-width alphabets (uppercase and lowercase), half-width numbers and half-width symbols.',
        'form-error-user-id-valid': 'Please register only half-width alphabets (uppercase and lowercase), half-width numbers and half-width symbols.',
        'form-error-mail-format': 'Invalid mail format',
        'form-error-number': 'Input number',
        'form-error-integer': 'Input integer',
        'form-error-mx-not-found': 'Mail server not exists (string after atmark may be wrong)',
        'form-message-confirm': 'Click the \'Apply\' button to continue.',
        'form-message-completed': 'Thank you for your application. We\'ll send information as soon as the service is ready.',
        'forgot-password-completed': 'An email has been sent to the registered address.' +
            '<br/>Please access the address in the email and change your password.' +
            '<br/><br/>If you do not receive the e-mail, please check for spam.' +
            '<br/><br/>If you still do not receive the email, it is possible that the email address is not registered.' +
            '<br/>Please check your email address or contact us!',
        'reset-password-unable': 'Unable to reset password',
        'reset-password-token-invalid': 'If the E-mail address is incorrect or 24 hours have passed since password reset application.' +
            '<br/><br/>To apply for a password reset again, ',
        'lbl-here': 'Here',
        'reset-password-completed': 'Password reset',
        'reset-password-completed-content': 'Please log in again with the reset password.' +
            '<br />Click here for OrthoComm, ',
        'lbl-login': 'Login',
        'lbl-login-here': 'Login',
        'reset-password-invalid-info': 'The Organization ID, User ID, or Email is different from the application',
        'forgot-password-invalid-info': 'The information you entered is incorrect',
        'title-plan-invisalign': 'Blue Plan',
        'subtitle-plan-invisalign': '',
        'title-plan-standard': 'Basic Charge',
        'title-plan-storage': 'Storage Charge',
        'title-device-pc': 'PC',
        'content-device-pc': ['OrthoComm can be run using standard web technologies. You can use OrthoComm in any OS, Windows, Mac OS and Linux.'],
        'title-device-mobile': 'Mobile',
        'content-device-mobile': ['We\'ll release an iPad App for clinics and iPhone / Android App for clients in future.'],
        'field-type-required': 'Required',
        'field-type-optional': 'Optional',
        'field-clinic': 'Clinic Name',
        'field-organization-id': 'Organization ID',
        'field-user-id': 'User ID',
        'field-location': 'Location',
        'field-location-long': 'State / City',
        'field-email': 'Email',
        'field-name': 'Contact person',
        'field-phone': 'Phone',
        'field-cases': 'Cases in the last year',
        'field-cases-long': 'Cases in the last year',
        'field-alignerSystem': 'Aligner System',
        'field-comment': 'Question or Comment',
        'field-campaign-code': 'Campaign Code',
        'field-password': 'Password',
        'field-password_confirmation': 'Confirm password',
        'form-error-password-not-match': 'Password do not match',
        'option-invisalign': 'Invisalign',
        'option-ecligner': 'Ecligner',
        'option-operaGrass': 'OperaGrass',
        'option-aquaSystem': 'AquaSystem',
        'option-clearAligner': 'Alear Aligner',
        'option-etc': 'etc.',
        'mon-150': '$150 / month',
        'mon-300': '$300 / month',
        'mon-500': '$500 / month',
        'mon-800': '$800 / month',
        'Upto500': 'Up to 500',
        'Upto2000': 'up to 2000',
        'Upto5000': 'up to 5000',
        'Upto10000': 'up to 10000',
        'Imageupload': 'Image upload',
        'Visits': 'Estimated Numbers of Patients’ Visits',
        '50-month': '50 / month',
        '200-month': '200 / month',
        '500-month': '500 / month',
        '1000-month': '1000 / month',
        'Profile': 'Profile',
        'SlideShow': 'Slide Show',
        'AlignerManagement': 'Aligner Management',
        'PatientMobile': 'Patient Mobile App',
        'Compliance': 'Compliance Management (registration, graph)',
        'StorageCharge': 'Storage Charge',
        'Upto1TB': 'Up to 1TB',
        'Free': 'Free',
        'Over1TB': 'Over 1TB',
        'additional': '$30 for every additional 100GB',
        'tutorial-homescreen': 'Login and Homescreen',
        'tutorial-homescreen-detail': 'In this tutorial, we’ll learn about how to login and look at different menus on the home screen.',
        'tutorial-patient': 'Patient Search',
        'tutorial-patient-detail': 'In this tutorial, we’ll learn how to seach for clients.',
        'tutorial-registering': 'Registering a new client',
        'tutorial-registering-detail': 'In this tutorial, we’ll learn how to register a new client.',
        'tutorial-upload': 'Uploading new images',
        'tutorial-upload-detail': 'In this tutorial, we’ll learn how to upload new images to client profiles.',
        'tutorial-viewer': 'Using the Image Viewer',
        'tutorial-viewer-detail': 'In this tutorial, we’ll explore the client main screen in more detail.',
        'tutorial-registering-ali': 'Registering Aligners',
        'tutorial-registering-ali-detail': 'In this tutorial we will learn about aligner registration.',
        'tutorial-aligner': 'Aligner adjustments and cancellation',
        'tutorial-aligner-detail': 'In this tutorial, we’ll learn about how to adjust aligner schedules and make cancellations.',
        'tutorial-recording': 'Recording compliance',
        'tutorial-recording-detail': 'In this tutorial, we’ll learn how to record compliance.',
        'tutorial-displaying': 'Displaying accelerated device results',
        'tutorial-displaying-detail': 'In this tutorial, we’ll learn how to display accelerated device results.',
        'tutorial-staff': 'Staff and Account Settings',
        'tutorial-staff-detail': 'In this tutorial, we will learn about staff and account settings.',
        'tutorial-custom': 'Customizing OrthoComm',
        'tutorial-custom-detail': 'In this tutorial, we will learn how to further customize OrthoComm to better fit your practice.',
        'faq-title': 'What kind of hardware does OrthoComm need?',
        'faq-short': 'OrthoComm can be run using standard web technologies. You can use OrthoComm in any OS, Windows, Mac OS and Linux.',
        'Browser': 'Browser',
        'Version': 'Version',
        'Status': 'Status',
        'Status_2': 'Status',
        'Recent': 'Recent',
        'install': '(install)',
        'Recommended': 'Recommended',
        'future': 'in future',
        'faq-title-suppor': 'What device will mobile app support?',
        'faq-title-suppor-short': 'We will release an iPad App for clinics and iPhone / Android App for clients in future.',
        'Platform': 'Platform',
        'faq-ios8': 'iOS8 or later',
        'androi-4': '4.1 or later',
        'clinic-app': 'in future (client app)',
        'clinic-app-2': 'in future (clinic app)',
        'Address': 'Address',
        'Phone': 'Phone',
        'Address-detail': 'Kataoka Building 2-39-5 Hongo Bunyoku <br> Tokyo 113-0033 Japan',
        'Phone-detail': '+81-3-5800-0040',
        'email-detail': 'contact@orthocomm.net',
        'email-last-message': 'Click the "Apply" button to continue.',

        'app-status-aligner': 'Aligner',
        'app-status-mail-history': 'Mail History',
        'app-status-broadcast-mail-history': 'Broadcast Mail History',
        'app-status-chat-history': 'Chat History',
        'app-status-audit': 'Audit',
        'app-status-access-log': 'Access Log',
        'app-status-account-log': ' Account Log ',

        'app-setting-staff': 'Staff',
        'app-setting-clinic': 'Clinic',
        'app-setting-common-settings': 'Common Settings',
        'app-setting-option-settings': 'Behaviour Settings',
        'app-setting-mail': 'Mail Settings',
        'app-setting-mail-titile': 'Mail Settings',
        'app-setting-device': 'Device Settings',
        'app-setting-payment': 'Payment',
        'app-setting-cancellation': 'Cancellation',
        'app-setting-document': 'Document',
        'app-common-display-type': 'Display Type',
        'app-common-document': 'Document',
        'app-common-registered-email': 'Registered e-mail address.<br> Please contact us if you want to change.',
        'app-setting-mail-validate-title': 'Please input 「Broadcast Mail Title」',
        'app-setting-mail-validate-text-html': 'Please input 「Broadcast Mail Text」 or 「Broadcast Mail HTML」',

        'app-setting-staff-doctor': 'Doctor',
        'app-setting-staff-cordinator': 'Cordinator',
        'app-setting-staff-administrator': 'Administrator',
        'app-setting-staff-administrator-2': '(Administrator)',
        'app-setting-staff-auth': 'Yes',
        'app-setting-staff-veryweak': 'Very Weak',
        'app-setting-staff-weak': 'Weak',
        'app-setting-staff-strong': 'Strong',

        'app-setting-option': 'Option Settings',
        'app-setting-option-form': 'Form Settings',

        'app-client-select-client': 'Select Client',
        'app-client-new-client': 'New Client',

        'app-common-Timezone': 'Timezone',
        'app-common-Country': 'Country',
        'app-common-City': 'City',
        'app-common-Address': 'Address',
        'app-common-Phone': 'Phone',
        'app-common-ClinicName': 'Clinic Name',
        'app-common-Person': 'Contact Person',
        'app-common-Plan': 'Plan',
        'app-common-Contact': 'Contact to OrthoComm Team',

        'app-devive-yes': 'Yes',
        'app-devive-no': 'No',

        'app-top-commuication': 'Top',
        'app-list-commuication': 'List',
        'app-new-commuication': 'New Room',

        'ok': 'OK',
        'ng': 'NG',

        'app-timeline': 'Timeline',
        'app-communication': 'Communication',
        'app-setting-commuication': 'Settings',
        'app-back-commuication': 'Back',

        'app-client-search-new': 'New Client',
        'app-client-search': 'Select Client',
        'app-client-search-name': 'Name',
        'app-client-search-lastDate': 'Last Visit',
        'app-client-search-firstDate': 'First Visit',
        'app-client-search-birthday': 'Birthday',
        'app-client-search-accelationDevice': 'Acceleration Device',
        'app-client-search-case': 'Case',
        'app-client-search-clinic': 'Clinic',
        'app-client-search-clientNumber': 'Client Number',
        'app-client-search-anyphone': 'Phone',
        'app-client-search-anyaddress': 'Address',
        'app-client-search-doctor': 'Doctor',
        'app-client-search-presentationName': 'Presentation Name',
        'app-client-search-lastSend': 'Last Send',
        'app-client-search-chatSend': 'Chat Last Send',
        'app-client-search-record-lastSend': 'The results will be displayed within the last 3 days including the selected date.',

        'app-client-detail-top': 'Top',
        'app-client-detail-profile': 'Profile',
        'app-client-detail-aligner': 'Aligner',
        'app-client-detail-compliance': 'Compliance',
        'app-client-detail-device': 'Device',
        'app-client-detail-timeline': 'Timeline',
        'app-client-detail-mail': 'Mail History',
        'app-client-detail-audit': 'Audit',
        'app-client-detail-communication': 'Communication',

        'alert-content': 'Your change has not been saved. Please determine to discard or save the change, before you leave this page.',
        'alert-title': 'Alert',
        'alert-title-send-mail': 'Send Movie Mail',
        'alert-cancel': 'Cancel',
        'alert-discard': 'Discard',
        'alert-save': 'Save',
        'alert-remove': 'Remove',
        'alert-content-2': 'Are you sure to remove this item?',
        'alert-content-save': 'Are you sure to save this item? ',
        'alert-content-send-movie': 'Are you sure to send this movie? ',
        'alert-content-discard': 'Are you sure to discard this item?',
        'alert-validate' : 'Please check validate!',
        'mail-history-type-test': 'Test',
        'mail-history-type-appoint': 'Appoint',
        'mail-history-type-chatReceived': 'Chat received',
        'mail-history-type-optional': 'Optional',
        'mail-history-type-broadcast': 'Broadcast',
        'mail-history-type-consultationOnline': 'Online Consultation',
        'mail-history-type-aligner': 'Aligner On Time',
        'mail-history-type-Profile Received': 'Profile Received',
        'mail-history-type-Profile Request': 'Profile Request',
        'mail-history-type-movie': 'Movie',
        'mail-history-type-deviceMail': 'Device Mail',
        'mail-history-type-imagesReceivedMail': 'Photo Received',
        'mail-history-status-completed': 'Sent',
        'mail-history-status-reserved': 'Reserved',
        'mail-history-status-canceled': 'Canceled',

        'app-client-detail-compliance-Registration': 'Registration',
        'app-client-detail-compliance-Effect-Title': 'Device Effect ',
        'app-client-detail-compliance-Aligner-Title': 'Aligner Compliance',
        'app-client-detail-compliance-Device-Title': 'Device Compliance',


        'app-client-detail-compliance-AcceleDent': 'AcceleDent',
        'app-client-detail-compliance-OrthoPulse': 'OrthoPulse',

        'app-client-detail-compliance-Registration-btn': 'Registration',
        'app-client-detail-compliance-Effect': 'Effect',
        'app-client-detail-compliance-Aligner': 'Aligner',
        'app-client-detail-compliance-Device': 'Device',
        'chewieCompliance-good': 'Good',
        'chewieCompliance-normal': 'Normal',
        'chewieCompliance-bad': 'Bad',
        'chewieCompliance-na': 'Not Used',
        'elasticCompliance-good': 'Good',
        'elasticCompliance-normal': 'Normal',
        'elasticCompliance-bad': 'Bad',
        'elasticCompliance-na': 'Not Used',

        'ReceiveDevice-Yes': 'Yes',
        'ReceiveDevice-No': 'No',


        'ChewieCompliance-Good': 'Good',
        'ChewieCompliance-Normal': 'Normal',
        'ChewieCompliance-Bad': 'Bad',
        'ChewieCompliance-NotUsed': 'Not Used',

        'ChewiePassed-None': 'None',
        'ChewiePassed-1': '1',
        'ChewiePassed-2': '2',
        'ChewiePassed-3': '3',
        'ChewiePassed-4': '4',

        'ElasticCompliance-Good': 'Good',
        'ElasticCompliance-Normal': 'Normal',
        'ElasticCompliance-Bad': 'Bad',
        'ElasticCompliance-NotUsed': 'Not Used',

        'CompliancePassed-None': 'None',
        'CompliancePassed-1': '1',
        'CompliancePassed-2': '2',
        'CompliancePassed-3': '3',
        'CompliancePassed-4': '4',
        'app-setting-staff-very-strong': 'Very Strong',

        device: {
            notactivated: {
                status: 'Not Activated',
                step: 'Input activation code',
            },
            newitem: {
                status: 'New Device',
                step: {
                    mail: 'Please click email button',
                    qrcode: 'Please click QR code button',
                    text: 'Please notify url to a client',
                },
            },
            inuse: {
                status: 'In Use',
                step: '',
            },
            activated: {
                status: 'Activated',
                step: 'Please ask client to click "login" button',
            },
        },

        'title-modal-qrcode': 'Please install OrthoComm App and read this QR code with the app',
        'tap-to-start': 'Tap to start',
        'innit-account-setting-title': 'Account Setting',
        'innit-account-setting-content': 'Organization ID is used to login. Input string you wish to use as Organization ID. You can use alphanumeric charactors, hyphen and underbar as Organization ID.　Organization ID is also used as a part of the default maill address for mails sended by OrthoComm',
        'innit-account-account-too-short': 'The organization ID is too short. Input string longer than 6 characters.',
        'innit-account-exis': 'This organization ID is already used.',
        'innit-account-can-use': 'You can use this organization ID. ',
        'innit-basic-setting-title': 'Basic Setting',
        'innit-basic-setting-content': 'You can change this setting later in "Top -> Setting -> Common".',
        'innit-bassic-setting-state': 'State',
        'innit-dortor-setting-title': 'Doctor Setting',
        'innit-doctor-setting-content': 'Doctor Name',
        'innit-password-strong-level-very-weak': 'Very Weak',
        'innit-password-strong-level-weak': 'Weak',
        'innit-password-strong-level-strong': 'Strong',
        'innit-password-strong-level-very-strong': 'Very Strong',
        'innit-org-name': 'Organization Name',
        'innit-input-requied': 'This field is required',
        'innit-input-pattern': 'Organization ID is not correct. Please check again.',
        'client-profile-use-treatment-tab': 'Device (Use of Treatment Menu)',
        'client-profile-use-treatment-tab-on': 'Use',
        'client-profile-use-treatment-tab-off': 'Not Use',
        'client-detail-profile-confirm-submit-message': 'Are you sure to save this item?',
        'client-detail-profile-confirm-submit-title': 'Save',
        'client-detail-profile-confirm-submit-lable-ok': 'OK',
        'client-detail-profile-confirm-submit-lable-cancel': 'Cancel',
        'client-detail-profile-confirm-test-mail-message': 'Are you sure to send a test mail?',
        'client-detail-profile-confirm-device-mail-message': 'Are you sure to send a device mail?',
        'client-detail-profile-confirm-appoint-mail-message': 'Are you sure to send an appoint mail?',
        'client-detail-profile-confirm-optional-mail-message': 'Are you sure to send an optional mail?',
        'client-detail-profile-confirm-test-mail-title': 'Send Test Mail',
        'client-detail-profile-confirm-device-mail-title': 'Send Device Mail',
        'client-detail-profile-confirm-appoint-mail-title': 'Send Appoint Mail',
        'client-detail-profile-confirm-optional-mail-title': 'Send Optional Mail',
        'client-detail-profile-confirm-test-mail-alert-err': 'Please save or descard this item',
        'client-detail-profile-confirm-remove-message': 'Are you sure to remove this item?',
        'client-detail-profile-confirm-remove-title': 'Remove',
        'client-detail-device-activation-alert-err': 'Invalid Activation code',
        'app-client-detail-top-klin': 'ClinCheck',
        'app-client-detail-top-Registration': 'Registration',
        'app-client-detail-top-Slideshow': 'Slideshow',
        'app-client-detail-top-Comparison': 'Comparison',
        'app-client-detail-top-Simulation': 'Simulation',
        'day': 'days',
        'month': 'month(s)',
        'cancel': 'cancel',
        'canceled': 'Canceled',
        'pay-ment': 'Payment',

        'new-plan-payment': 'Payment',
        'new-plan-price-free': 'Free',
        'new-plan-price-light': '11,000JPY/month',
        'new-plan-price-basic': '17,000JPY/month',
        'new-plan-price-standard': '27,000JPY/month',
        'new-plan-price-professional': '41,000JPY/month',
        'new-plan-patient': 'Patient number',
        'new-plan-client-number-free': '0~3/month',
        'new-plan-client-number-light': '4~50/month',
        'new-plan-client-number-basic': '51~200/month',
        'new-plan-client-number-standard': '201~1000/month',
        'new-plan-client-number-professional': '1001~/month',
        'new-plan-register-mail': 'Register email',

        'login-register-now': 'Register new member here',
        'login-link-tutotial': 'Tutorial',
        'login-forgot-organization-id': 'If you don\'t know your Organization ID, ',
        'login-contact-us': 'Please contact us.',
        'login-forgot-user-id': 'If you don\'t know your User ID,',
        'login-contact-admin': 'Please contact your organization administrator for general authority',
        'login-is-admin': 'Organization administrator ',
        'login-forgot-password': 'If you want to unlock the login lock or reset the password, ',
        'login-link-reset-password': 'please reset the password here.',
        'SendPhotoRequest': 'Remote Communication',
        'SendProfileRequest': 'Send profile registration request email.',
        'ButtonSendMail': 'Send Mail',
        'TextSendMailLine1': 'The name of client cannot be entered automatically.',
        'TextSendMailLine2': 'The URL of the photo upload page is automatically inserted.',
        'TextSendMailProfileLine2': 'The URL of the profile registration page is automatically inserted.',
        'receiver': 'Receiver',
        'subject': 'Subject',
        'body': 'Body',
        'placeholder-body': 'Please enter the medical consultation schedule, medical consultation URL, etc.',
        'placeholder-body-1': 'Please enter your profile registration request text, etc.',
        'validate-email-required': 'Please enter the email.',
        'validate-subject-required': 'Please enter the subject.',
        'validate-subject-maxlenght': 'Please enter the subject within 200 characters.',
        'validate-body-required': 'Please enter the body.',
        'consultationOnline': 'Online Consultation',
        'deviceMail': 'Device Mail',
        'imagesReceivedMail': 'Photo Received',

        'broadcast-mail-transmission': 'Broadcast mail transmission',
        'confirm-send-broadcast-mail': 'Are you sure to send this item?',
        'send-broadcast-mail': 'Send Broadcast Mail',
        'sender-name-label': 'Mail Sender Name',
        'sender-address-label': 'Mail Sender Address',
        'carbon-copy-address-email': 'Carbon Copy Email Address (Comma Separated)',
        'move-mail-title': 'Movie Mail Title',
        'move-mail-text': 'Movie Mail Text',
        'move-mail-html': 'Movie Mail HTML',
        'aligner-mail-title': 'Aligner Mail Title',
        'aligner-mail-text': 'Aligner Mail Text',
        'aligner-mail-html': 'Aligner Mail HTML',
        'test-mail-title': 'Test Mail Title',
        'test-mail-text': 'Test Mail Text',
        'test-mail-html': 'Test Mail HTML',
        'appoint-mail-title': 'Appoint Mail Title',
        'appoint-mail-text': 'Appoint Mail Text',
        'appoint-mail-html': 'Appoint Mail HTML',
        'optional-mail-title': 'Optional Mail Title',
        'optional-mail-text': 'Optional Mail Text',
        'optional-mail-html': 'Optional Mail HTML',
        'broadcast-mail-title': 'Broadcast Mail Title',
        'broadcast-mail-text': 'Broadcast Mail Text',
        'broadcast-mail-html': 'Broadcast Mail HTML',
        'communication-video-max-upload-size-exceeded': 'The maximum video size you can upload is 256Mb. Please try again.',
        'communication-converting': 'When "Converting ..." is displayed, the video is being converted. Please wait. <br>Conversion usually takes about twice the playback time. (Example: 1 minute video => about 2 minutes)<br> It may take a little longer depending on the video size.<br>You can upload up to 256MB.',
        'download-notice': 'Click to download file.',
        'download': 'Download',
        //app-client
        'app-no-aligner': 'No aligner registered.',
        'app-chat-send': 'Send',
        'app-chat-back': 'Back',
        'app-setting-logout': 'Logout',
        'app-setting-name': 'Name',
        'app-setting-version': 'Version',
        'app-setting-release-code': 'Release Code',
        'app-setting-prolicy': 'Privacy policy',

        // notification message
        'client-replied': ' You\'ve got message.',
        'result-contains-no-items': 'Result contains no items.',

        'app-common-ZipCode': '郵便番号 (領収書用)',
        'app-common-BusinessName': '法人名 (領収書用)',
        'app-common-TaxRate': '税率 (領収書用)',
        'app-client-detail-receipt': 'receipt',
        payment: {
            label: 'Payment',
            register_card: 'Register card',
            current_month: 'Usage this month',
            history: 'History',
            btn_invoice: 'Invoice',
            btn_receipt: 'Receipt',
            table: {
                target_period: 'Target period',
                year_month: 'Payment period',
                amount: 'Usage fee',
                status: 'Payment status',
                number_client: 'Number of client',
                payment_date: 'Payment completion date',
                amount_current: 'Expected amount',
                download_invoice: 'Download form',
            },
            statues: {
                '未決済': 'In process',
                '成功': 'OK',
                '失敗': 'NG',
                '不要': 'Unnecessary',
            },
            unnecessary: 'Unnecessary',
            messages: {
                payment_card_not_register: 'Please register a credit card.',
                payment_failure: 'Payment by credit card failed.<br/>Your credit card may have expired.<br/>Please register and review.',
                account_maybe_delete: 'If you do not register your credit card by the next month, your account will be deleted.',
            },
        },
        document: {
            tutorial: 'Tutorial(Video)',
            tutorial_v: 'Tutorial',
            document: 'Document',
            privacy_policy: 'Privacy Statement (PDF)',
        },
        'toogle-datepicker': 'Empty',
        'app-setting-behaviour-tooth': 'Photo Auto Flip',
        'app-setting-behaviour-tooth-default': 'Not Flip',
        'app-setting-behaviour-tooth-vertical': 'Vertical Flip',
        'app-setting-behaviour-tooth-horizontal': 'Horizontal Flip',
    }
    ///// JANPAN
    arrJAN = {
        'menu-top': 'トップ',
        'menu-feature': '機能',
        'menu-price': 'プラン',
        'menu-price-2': 'プラン名',
        'menu-Price': '料金',
        'menu-environment': '対応環境',
        'menu-trial': '無料お試し',
        'menu-campaign': 'キャンペーン',
        'menu-company': '会社情報',
        'menu-support': 'サポート',
        'menu-contact': 'お問い合わせ',
        'menu-faq': 'よくある質問',
        'menu-tutorial': 'チュートリアル',
        'menu-privacy-statement': 'プライバシーポリシー',
        'menu-specified': '特定商取引法に基づく表記',
        'menu-specified-link': 'assets/img/document/specified_commercial_transactions.pdf',
        'title-application': '無料お試し、申し込みフォーム',
        'title-feature': 'の機能',
        'title-goal': 'の目指すもの',
        'title-goal-stt': false,
        'title-contact': 'お問い合わせフォーム',
        'title-forgot-password': 'Password再設定申請',
        'title-reset-password': 'Password再設定',
        'button-next': '次の画面へ',
        'button-back': '戻る',
        'button-apply': '申し込む',
        'message-heading': 'アライナー矯正に必要な機能が全て手に入る、アライナー矯正支援サービス',
        'message-heading-sub-status': true,
        'message-heading-sub': '画像管理、アライナー管理、予約管理、矯正加速装置の管理、患者様用アプリ・・・・アライナー矯正を成功させるために必要な機能が、月額6000円より。',
        'message-heading-last': ' 1ヶ月間無料お試しキャンペーン中。',
        goals: ['アライナー矯正は、患者様のモチベーションの維持が、成功の鍵を握ります。スライド、グラフ、メール、患者様用アプリを駆使して、患者様のモチベーションを高め、<span style="' + this.emphasis_large + '">アライナーや加速矯正装置の使用率を改善</span>します。', 'アライナー枚数の計算、画像の管理、コンプライアンス管理、本格的にアライナー矯正を行うときに避けられない<span style="' + this.emphasis_large + '">煩雑な事務処理から解放</span>します。', '患者満足度の向上と、グラフィカルな治療紹介で、<span style="' + this.emphasis_large + '">成約率と紹介率を向上</span>させ、クリニックの経営をサポートします。'],
        'feature-image-management-title': '画像管理・スライドショー',
        'feature-image-management-message': ['過去から現在の治療スライドショーを表示することで、患者様のモチベーションを高め、アライナー矯正を成功させます。', '新規患者様への治療紹介に使うことで、成約率をアップ。', 'アライナー矯正では、一人の患者様につき、数百枚の治療写真が必要になる場合もあります。画像を一括管理することで業務を効率化します。'],
        'feature-aligner-management-title': 'アライナー管理',
        'feature-aligner-management-message': ['簡単操作で、面倒なアライナーの枚数計算を一括管理。きめ細かな患者指導で、アライナー矯正を成功に導きます。', 'アライナー交換日に自動でメールを送る、Aligner on Time。', '患者様用アプリでは、カレンダー形式でアライナー交換時期を表示します（5月提供予定）'],
        'feature-compliance-management-title': 'コンプライアンス管理',
        'feature-compliance-management-message': ['アライナーの装着率や、矯正加速装置（AcceleDent<sup>&reg;</sup>やOrthoPulse&trade;）の使用状況を管理し、効果をビジュアル化することで、患者様のモチベーション維持に貢献します。', '矯正加速装置については、全く利用しなかった場合（14日）、理想的な使用の場合（3日、5日）と、現在のペースでの予想完了日を比較して、患者様に「現在の状況」を適切に把握していただき、矯正加速装置の利用率を高めます。'],
        'feature-mail-title': 'メール',
        'feature-mail-message': ['アライナー交換日に患者様にメールでお知らせ。キャンセル率の低下に', 'シミュレーション動画をメールで患者様に送信することで患者様とゴールの共有を図ります。'],
        'feature-smart-phone-app-title': '患者様用アプリ(5月提供予定）',
        'feature-smart-phone-app-message': [' アライナー交換日カレンダーとアライナー交換日の通知で、アライナーの交換忘れを防ぎます。', 'クリチェック動画や、治療スライドショーをいつでも確認でき、治療へのモチベーションを高めます。', 'アライナーや矯正加速装置の利用率を表示し、これらの利用率を高めます。', '次回来院日の確認、クリニックの予約ができます。', 'クリニック様向け画面から、患者様向けアプリのプレビューができ、操作説明に利用することができます。'],
        'form-error-required': '必須項目です',
        'form-error-userid-exist': 'このユーザーIDは既に登録されています。',
        'form-error-password-valid': '半角英字 (大文字と小文字)、半角数字と半角記号のみ登録してください。',
        'form-error-user-id-valid': '半角英字 (大文字と小文字)、半角数字と半角記号のみ登録してください。',
        'form-error-mail-format': 'メールの形式が正しくありません',
        'form-error-number': '数字で入力してください',
        'form-error-integer': '整数で入力してください',
        'form-error-mx-not-found': 'メールサーバが存在しません。メールアドレスのアットマーク(@)以降の部分が間違っている可能性があります',
        'form-message-confirm': '以下の内容でよろしければ、「申し込む」ボタンを押してください。',
        'form-message-completed': 'お申し込みありがとうございます。準備ができ次第、ご案内を差し上げます。',
        'forgot-password-completed': '登録したアドレス宛にメールをお送りしました。' +
            '<br/>メールに記載されているアドレスにアクセスして、パスワード変更を行って下さい。' +
            '<br/><br/>メールが届かない場合は、迷惑メールに入ってないか確認して下さい。' +
            '<br/><br/>それでもメールが来ない場合は、そのメールアドレスが登録されていない可能性がございます。' +
            '<br/>メールアドレスをご確認いただくか、運営までお問い合わせください。 ',
        'reset-password-unable': 'パスワードを再設定出来ません',
        'reset-password-token-invalid': 'メール記載のアドレスが間違っているか、' +
            '<br/>パスワード再設定申請から24時間が経過しています。' +
            '<br/>再度、パスワード再設定申請をする場合は',
        'lbl-here': 'こちら',
        'reset-password-completed': 'パスワードを再設定しました',
        'reset-password-completed-content': '再設定したパスワードでログインしなおしてください。' +
            '<br />OrthoCommログインは',
        'lbl-login': 'ログイン',
        'lbl-login-here': 'こちら',
        'forgot-password-invalid-info': '入力した情報に間違いがあります',
        'reset-password-invalid-info': 'Organization ID、User ID、またはEmailが申請した内容と異なります',
        'title-plan-invisalign': 'Blueプラン',
        'subtitle-plan-invisalign': '',
        'content-plan-invisalign': ['前年のInvisalign&reg;の年間症例数に応じて、固定金額でご利用いただけるプランです。Invisalign&reg;をご利用の患者様については、全ての機能を無制限でお使いいただけます。', '開始後1ヶ月は無料でご利用いただけます。'],
        'title-plan-standard': '基本料金',
        'title-plan-storage': 'データ保管料金',
        'content-plan-standard': ['毎月新規患者様5人まで、基本料金内でお使いいただけるプランです。患者管理、予約管理、アライナー計算機能などは、基本料金内で、人数無制限でお使いいただけます。', '開始後1ヶ月は無料でご利用いただけます。'],
        'title-device-pc': 'PC',
        'content-device-pc': [' Windows / Mac / Linux等、OSを問わず、ブラウザが使える環境ならどんなPCでもお使いいただけます。', 'お使いのパソコンに、対応ブラウザがインストールされていない場合は、無料でインストールしてお使いいただけます'],
        'title-device-mobile': 'モバイル',
        'content-device-mobile': [' 患者様向けアプリは、主要スマートフォンに対応予定です。'],
        'field-type-required': '必須',
        'field-type-optional': '任意',
        'field-clinic': 'クリニック名',
        'field-organization-id': 'Organization ID',
        'field-user-id': 'User ID',
        'field-location': '所在地',
        'field-location-long': '都道府県 / 市区町村',
        'field-email': 'Email',
        'field-name': '担当者名',
        'field-phone': '電話番号',
        'field-cases': '年間症例数',
        'field-cases-long': 'アライナー矯正年間症例数',
        'field-alignerSystem': 'アライナーシステム',
        'field-comment': '内容',
        'field-campaign-code': 'キャンペーン・コード',
        'field-password': 'Password',
        'field-password_confirmation': 'Password(同じもの)',
        'form-error-password-not-match': 'Passwordが一致しません',
        'option-invisalign': 'インビザライン',
        'option-ecligner': 'イークライナー',
        'option-operaGrass': 'オペラグラス',
        'option-aquaSystem': 'アクアシステム',
        'option-clearAligner': 'クリアアライナー',
        'option-etc': 'その他',
        'mon-150': '¥15000 / 月',
        'mon-300': '¥30000/月',
        'mon-500': '¥50000/月',
        'mon-800': '¥80000/月',
        'Upto500': '月500枚まで',
        'Upto2000': '月2000枚まで',
        'Upto5000': '月5000枚まで',
        'Upto10000': '月10000枚まで',
        'Imageupload': '画像アップロード',
        'Visits': '患者来院数の目安',
        '50-month': '月50人程度',
        '200-month': '月200人程度',
        '500-month': '月500人程度',
        '1000-month': '月1000人程度',
        'Profile': 'プロフィール編集',
        'SlideShow': 'スライドショー',
        'AlignerManagement': 'アライナー管理',
        'PatientMobile': '患者向けスマートフォンアプリ',
        'Compliance': 'コンプライアンス管理（登録、グラフ）',
        'StorageCharge': 'データ保管料金',
        'Upto1TB': '1Tバイトまで',
        'Free': '無料',
        'Over1TB': '1Tバイト以上',
        'additional': '100GBを超えるごとに$30',
        'title-view': 'すべてを見る',
        'tutorial-homescreen': 'ログインとホーム画面',
        'tutorial-homescreen-detail': '',
        'tutorial-patient': '患者を検索する',
        'tutorial-patient-detail': '',
        'tutorial-registering': '新しい患者を登録する',
        'tutorial-registering-detail': '',
        'tutorial-upload': '画像をアップロードする',
        'tutorial-upload-detail': '',
        'tutorial-viewer': '画像を見る',
        'tutorial-viewer-detail': '',
        'tutorial-registering-ali': 'アライナーを登録する',
        'tutorial-registering-ali-detail': '',
        'tutorial-aligner': 'アライナーの修正とキャンセル',
        'tutorial-aligner-detail': '',
        'tutorial-recording': 'コンプライアンスを登録する',
        'tutorial-recording-detail': '',
        'tutorial-displaying': '加速矯正装置の効果を表示する',
        'tutorial-displaying-detail': '',
        'tutorial-staff': 'ドクター、スタッフ、アカウントの設定をする',
        'tutorial-staff-detail': '',
        'tutorial-custom': 'カスタマイズする',
        'tutorial-custom-detail': '',
        'faq-title': 'OrthoCommを使うのにどのような機材が必要ですか？',
        'faq-short': '<p>Windows / Mac / Linux等、OSを問わず、ブラウザが使える環境ならどんなPCでもお使いいただけます。</p><p>お使いのパソコンに、対応ブラウザがインストールされていない場合は、無料でインストールしてお使いいただけます。</p>',
        'Browser': 'ブラウザ',
        'Version': '対応バージョン',
        'Status': 'ステータス',
        'Status_2': '対応状況',
        'Recent': '最新版',
        'install': '(インストール)',
        'Recommended': '推奨',
        'future': '対応予定',
        'faq-title-suppor': '患者様向けアプリはどのような端末で使うことができますか？',
        'faq-title-suppor-short': '患者様向けアプリは、主要スマートフォンに対応予定です。。',
        'Platform': 'プラットフォーム',
        'faq-ios8': 'iOS8以上',
        'androi-4': '4.1以上',
        'clinic-app': '対応予定',
        'clinic-app-2': '対応予定',
        'Address': '住所',
        'Phone': '電話',
        'Address-detail': '〒113-0033 東京都文京区本郷2-39-5 片岡ビル',
        'Phone-detail': '03-5800-0040',
        'email-detail': 'contact@orthocomm.net',
        'email-last-message': '以下の内容でよろしければ、「申し込む」ボタンを押してください。',

        'app-status-aligner': 'アライナー',
        'app-status-mail-history': 'メール履歴',
        'app-status-broadcast-mail-history': '一斉送信メール履歴',
        'app-status-chat-history': 'チャット履歴',
        'app-status-audit': '監査',
        'app-status-access-log': 'アクセスログ',
        'app-status-account-log': 'アカウントログ',

        'app-setting-staff': 'スタッフ',
        'app-setting-clinic': 'クリニック',
        'app-setting-common-settings': '共通設定',
        'app-setting-option-settings': '動作設定',
        'app-setting-mail': 'メール設定',
        'app-setting-mail-titile': 'メール設定',
        'app-setting-device': 'デバイス設定',
        'app-setting-payment': '支払い',
        'app-setting-cancellation': '解約',
        'app-setting-document': 'ドキュメント',
        'app-common-display-type': 'Display Type',
        'app-common-document': 'ドキュメント',
        'app-common-registered-email': '登録メールアドレス<br>※変更したい場合はご連絡ください。',
        'app-setting-mail-validate-title': '「Broadcast Mail Title」 を入力してください',
        'app-setting-mail-validate-text-html': '「Broadcast Mail Text」または 「Broadcast Mail HTML」 のどちらかを入力してください',

        'app-setting-staff-doctor': 'ドクター',
        'app-setting-staff-cordinator': 'コーディネーター',
        'app-setting-staff-administrator': '管理者',
        'app-setting-staff-administrator-2': '(管理者)',
        'app-setting-staff-auth': 'はい',
        'app-setting-staff-veryweak': 'とても弱い',
        'app-setting-staff-weak': '弱い',
        'app-setting-staff-strong': '強い',

        'app-setting-option': '選択肢設定',
        'app-setting-option-form': 'フォーム設定',

        'app-client-select-client': '患者選択',
        'app-client-new-client': '新規登録',

        'app-common-Timezone': 'タイムゾーン',
        'app-common-Country': '国',
        'app-common-City': '都道府県',
        'app-common-Address': '住所',
        'app-common-Phone': '電話番号',
        'app-common-ClinicName': '医院名',
        'app-common-Person': '担当者名',
        'app-common-Plan': '現在のプラン',
        'app-common-Contact': 'OrthoComm Teamに連絡する',
        'app-devive-yes': 'はい',
        'app-devive-no': 'いいえ',

        'app-top-commuication': 'トップ',
        'app-list-commuication': '一覧',
        'app-new-commuication': '新規登録',

        'ok': '◯',
        'ng': '✕',

        'app-timeline': 'タイムライン',
        'app-communication': 'チャット',
        'app-setting-commuication': 'Settings',
        'app-back-commuication': '戻る',

        'app-client-search-new': '新規登録',
        'app-client-search': '患者選択',
        'app-client-search-name': '氏名',
        'app-client-search-lastDate': '最終受診',
        'app-client-search-firstDate': '初回受診',
        'app-client-search-birthday': '誕生日',
        'app-client-search-accelationDevice': '加速装置',
        'app-client-search-case': '症例',
        'app-client-search-clinic': 'クリニック',
        'app-client-search-clientNumber': '患者番号',
        'app-client-search-anyphone': '電話番号',
        'app-client-search-anyaddress': '住所',
        'app-client-search-doctor': 'ドクター',
        'app-client-search-presentationName': 'プレゼンテーション名',
        'app-client-search-lastSend': '最終送信',
        'app-client-search-chatSend': 'チャット最終送信',
        'app-client-search-record-lastSend': '選択した日付を含めた過去3日を表示',


        'app-client-detail-top': 'トップ',
        'app-client-detail-profile': 'プロフィール',
        'app-client-detail-aligner': 'アライナー',
        'app-client-detail-compliance': 'コンプライアンス',
        'app-client-detail-device': 'デバイス管理',
        'app-client-detail-timeline': 'タイムライン',
        'app-client-detail-mail': 'メール履歴',
        'app-client-detail-audit': '監査',
        'app-client-detail-communication': 'チャット',

        'alert-content': ' 変更が保存されていません。ページを離れる前に、保存するか破棄するかを決めてください ',
        'alert-title': '警報',
        'alert-cancel': '戻る',
        'alert-discard': '破棄',
        'alert-save': '保存',
        'alert-remove': '削除',
        'alert-title-send-mail': '動画送信',
        'alert-content-2': '本当にこのアイテムを削除しますか?',
        'alert-content-save': 'このアイテムを保存しますか？',
        'alert-content-discard': '変更を破棄しますか？',
        'alert-validate' : '検証を確認してください!',
        'alert-content-send-movie': ' 本当に動画を送りますか? ',
        'mail-history-type-test': 'テスト',
        'mail-history-type-appoint': 'Appoint',
        'mail-history-type-chatReceived': 'Chat received',
        'mail-history-type-optional': 'Optional',
        'mail-history-type-broadcast': 'Broadcast',
        'mail-history-type-consultationOnline': 'オンライン相談',
        'mail-history-type-aligner': 'アライナー交換メール',
        'mail-history-type-Profile Received': 'プロフィール受信',
        'mail-history-type-Profile Request': 'プロフィール依頼',
        'mail-history-type-movie': '動画',
        'mail-history-type-deviceMail': 'デバイスメール',
        'mail-history-type-imagesReceivedMail': '写真受信',
        'mail-history-status-completed': '送信済',
        'mail-history-status-reserved': '送信予約',
        'mail-history-status-canceled': 'キャンセル',

        'app-client-detail-compliance-Registration': '登録',
        'app-client-detail-compliance-Effect-Title': '加速装置の効果',
        'app-client-detail-compliance-Aligner-Title': 'アライナーコンプライアンス',
        'app-client-detail-compliance-Device-Title': '加速装置コンプライアンス',
        'app-client-detail-compliance-AcceleDent': 'AcceleDent',
        'app-client-detail-compliance-OrthoPulse': 'OrthoPulse',
        'app-client-detail-compliance-Registration-btn': '登録',
        'app-client-detail-compliance-Effect': '効果',
        'app-client-detail-compliance-Aligner': 'アライナー',
        'app-client-detail-compliance-Device': '加速装置',
        'chewieCompliance-good': '使えている',
        'chewieCompliance-normal': 'まあまあ',
        'chewieCompliance-bad': '使えていない',
        'chewieCompliance-na': '必要なし',
        'elasticCompliance-good': '使えている',
        'elasticCompliance-normal': 'まあまあ',
        'elasticCompliance-bad': '使えていない',
        'elasticCompliance-na': '必要なし',
        'ReceiveDevice-Yes': 'はい',
        'ReceiveDevice-No': 'いいえ',
        'ChewieCompliance-Good': '使えている',
        'ChewieCompliance-Normal': 'まあまあ',
        'ChewieCompliance-Bad': '使えていない',
        'ChewieCompliance-NotUsed': '必要なし',
        'ChewiePassed-None': 'なし',
        'ChewiePassed-1': '1',
        'ChewiePassed-2': '2',
        'ChewiePassed-3': '3',
        'ChewiePassed-4': '4',
        'ElasticCompliance-Good': '使えている',
        'ElasticCompliance-Normal': 'まあまあ',
        'ElasticCompliance-Bad': '使えていない',
        'ElasticCompliance-NotUsed': '必要なし',
        'CompliancePassed-None': 'なし',
        'CompliancePassed-1': '1',
        'CompliancePassed-2': '2',
        'CompliancePassed-3': '3',
        'CompliancePassed-4': '4',
        'broadcast-mail-transmission': '一斉送信メール送信',
        'confirm-send-broadcast-mail': '本当にメールを送りますか？',
        'send-broadcast-mail': '一斉送信メールを送信する',
        'SendPhotoRequest': 'リモートコミュニケーション',
        'SendProfileRequest': 'プロフィール登録依頼メール送信',
        'ButtonSendMail': '送信する',
        'TextSendMailLine1': '相手のお名前は自動で入りません。',
        'TextSendMailLine2': '写真アップロードページのURLが自動で挿入されます。',
        'TextSendMailProfileLine2': 'プロフィール登録ページのURLが自動で挿入されます。',
        'receiver': '送信先選択',
        'subject': '件名',
        'body': '本文',
        'placeholder-body': '面談日程、面談URL等をご記載ください',
        'placeholder-body-1': 'プロフィール登録ご依頼文等をご記載ください',
        'validate-email-required': 'Emailを入力してください。',
        'validate-subject-required': '件名を入力してください。',
        'validate-subject-maxlenght': '件名を200文字以内で入力してください。',
        'validate-body-required': '本文を入力してください。',
        'consultationOnline': 'オンライン相談',
        'deviceMail': 'デバイスメール',
        'imagesReceivedMail': '写真受信',
        device: {
            notactivated: {
                status: 'アクティベーション待ち',
                step: 'アクティベーションコードを入力してください',
            },
            newitem: {
                status: '新規',
                step: {
                    mail: 'メールボタンをクリックしてください',
                    qrcode: 'QR code ボタンをクリックしてください',
                    text: 'URLを患者様に伝えてください',
                },
            },
            inuse: {
                status: '利用中',
                step: '',
            },
            activated: {
                status: 'アクティベーション済み',
                step: '患者様にログインボタンを押すように指示してください',
            },
        },

        'title-modal-qrcode': 'OrthoCommアプリをインストールし、アプリで以下のQRコードを読み込んでください',
        'tap-to-start': 'Tap to start',
        'innit-account-setting-title': 'アカウント設定',
        'innit-account-setting-content': 'Organization IDは今後のログインにお使いいただくものです。Organization IDとして希望する文字列を入力してください。英数字、アンダーバー、ハイフンを使用できます。Organization IDは、OrthoCommから患者様に送られるメールアドレスの一部としても使われます。',
        'innit-account-account-too-short': 'Organization IDが短すぎます。6文字以上を入力してください。',
        'innit-account-exis': 'このOrganization IDはすでに使用されています。別のOrganization IDを指定してください。',
        'innit-account-can-use': 'このOrganization IDを使用できます。',
        'innit-basic-setting-title': '基本設定',
        'innit-basic-setting-content': 'この設定は、 "トップ -> 設定 -> 共通設定"からいつでも変更することができます。',
        'innit-bassic-setting-state': '地域',
        'innit-dortor-setting-title': 'ドクター設定',
        'innit-doctor-setting-content': 'ドクター名',
        'innit-password-strong-level-very-weak': 'とても弱い',
        'innit-password-strong-level-weak': '弱い',
        'innit-password-strong-level-strong': '強い',
        'innit-password-strong-level-very-strong': 'とても強い',
        'innit-org-name': '組織名',
        'innit-input-requied': 'This field is required',
        'innit-input-pattern': 'Organization ID は不正です。再確認してください。',
        'client-profile-use-treatment-tab': 'デバイス管理(Treatmentメニューの利用)',
        'client-profile-use-treatment-tab-on': '利用する',
        'client-profile-use-treatment-tab-off': '利用しない',
        'client-detail-profile-confirm-submit-message': 'このアイテムを保存しますか？',
        'client-detail-profile-confirm-submit-title': '保存',
        'client-detail-profile-confirm-submit-lable-ok': 'OK',
        'client-detail-profile-confirm-submit-lable-cancel': '戻る',
        'client-detail-profile-confirm-test-mail-message': '本当にメールを送りますか?',
        'client-detail-profile-confirm-device-mail-message': 'デバイスメールを送信しますか？',
        'client-detail-profile-confirm-test-mail-title': 'テストメール送信',
        'client-detail-profile-confirm-appoint-mail-message': '本当にメールを送りますか？',
        'client-detail-profile-confirm-optional-mail-message': '本当にメールを送りますか？',
        'client-detail-profile-confirm-appoint-mail-title': 'アポイントメール送信',
        'client-detail-profile-confirm-optional-mail-title': '任意メール送信',
        'client-detail-profile-confirm-device-mail-title': 'デバイスメールを送信',
        'client-detail-profile-confirm-test-mail-alert-err': '先にこのアイテムを保存するか破棄してください',
        'client-detail-profile-confirm-remove-message': '本当にこのアイテムを削除しますか?',
        'client-detail-profile-confirm-remove-title': '削除',
        'client-detail-device-activation-alert-err': '無効なアクティベーションコード',
        'app-setting-staff-very-strong': 'とても強い',

        'app-client-detail-top-klin': 'クリンチェック',
        'app-client-detail-top-Registration': '登録',
        'app-client-detail-top-Slideshow': 'スライドショー',
        'app-client-detail-top-Comparison': '比較',
        'app-client-detail-top-Simulation': 'シミュレーション',
        'day': '日',
        'month': '月',
        'cancel': 'キャンセル',
        'canceled': 'Canceled',
        'pay-ment': '支払い',

        'new-plan-payment': 'お支払い',
        'new-plan-price-free': '無料',
        'new-plan-price-light': '11,000JPY/月',
        'new-plan-price-basic': '17,000JPY/月',
        'new-plan-price-standard': '27,000JPY/月',
        'new-plan-price-professional': '41,000JPY/月',
        'new-plan-patient': '患者登録数',
        'new-plan-client-number-free': '月0～3人',
        'new-plan-client-number-light': '月4～50人',
        'new-plan-client-number-basic': '月51～200人',
        'new-plan-client-number-standard': '月201～1000人',
        'new-plan-client-number-professional': '月1001人以上',
        'new-plan-register-mail': '登録メールアドレス',

        'login-register-now': '新規会員登録はこちら',
        'login-link-tutotial': 'チュートリアル',
        'login-forgot-organization-id': 'Organization IDが分からない場合は',
        'login-contact-us': 'お問合せください',
        'login-forgot-user-id': 'User IDが分からない場合は、',
        'login-contact-admin': '一般権限の方は組織の管理者へご確認ください',
        'login-is-admin': '組織の管理者の方は',
        'login-forgot-password': 'ログインロックの解除、Password再設定したい場合は',
        'login-link-reset-password': 'こちらからPassword再設定をしてください',
        'sender-name-label': 'Mail Sender Name',
        'sender-address-label': 'Mail Sender Address',
        'carbon-copy-address-email': 'Carbon Copy Email Address (Comma Separated)',
        'move-mail-title': 'Movie Mail Title',
        'move-mail-text': 'Movie Mail Text',
        'move-mail-html': 'Movie Mail HTML',
        'aligner-mail-title': 'Aligner Mail Title',
        'aligner-mail-text': 'Aligner Mail Text',
        'aligner-mail-html': 'Aligner Mail HTML',
        'test-mail-title': 'Test Mail Title',
        'test-mail-text': 'Test Mail Text',
        'test-mail-html': 'Test Mail HTML',
        'appoint-mail-title': 'Appoint Mail Title',
        'appoint-mail-text': 'Appoint Mail Text',
        'appoint-mail-html': 'Appoint Mail HTML',
        'optional-mail-title': 'Optional Mail Title',
        'optional-mail-text': 'Optional Mail Text',
        'optional-mail-html': 'Optional Mail HTML',
        'broadcast-mail-title': 'Broadcast Mail Title',
        'broadcast-mail-text': 'Broadcast Mail Text',
        'broadcast-mail-html': 'Broadcast Mail HTML',

        'communication-video-max-upload-size-exceeded': '動画登録の最大サイズは256Mbです。 もう一度お試しください',
        'communication-converting': '「Converting…」表示の時は動画を変換中です。お待ちください。<br>通常、変換には再生時間の約2倍の時間がかかります。(例：1分の動画→約2分)<br>動画サイズによってはもう少しかかる場合もあります。<br>256MBまでアップロード可能です。',
        'download-notice': 'ファイルをダウンロードしてください。',
        'download': 'ダウンロード',
        //app-client
        'app-no-aligner': 'アライナーはまだ登録されていません。',
        'app-chat-send': '送信',
        'app-chat-back': '戻る',
        'app-setting-logout': 'ログアウト',
        'app-setting-prolicy': 'プライバシーポリシー',
        'app-setting-name': '患者名',
        'app-setting-version': 'バーション',
        'app-setting-release-code': 'リリースコード',

        // notification message
        'client-replied': 'メッセージがあります。',
        'result-contains-no-items': '検索条件に一致するデータが見つかりません。',

        'app-common-ZipCode': '郵便番号 (領収書用)',
        'app-common-BusinessName': '法人名 (領収書用)',
        'app-common-TaxRate': '税率 (領収書用)',
        'app-client-detail-receipt': '領収書',
        payment: {
            label: '支払い',
            register_card: 'カード情報登録',
            current_month: '今月の使用状況',
            history: '決済履歴',
            btn_invoice: '請求書',
            btn_receipt: '領収書',
            table: {
                target_period: '対象年月',
                year_month: '対象年月',
                amount: '金額',
                status: '支払',
                number_client: '患者数',
                payment_date: '決済日',
                amount_current: '予想金額',
                download_invoice: '帳票ダウンロード',
            },
            statues: {
                '未決済': '未決済',
                '成功': '成功',
                '失敗': '失敗',
                '不要': '不要',
            },
            unnecessary: '不要',
            messages: {
                payment_card_not_register: 'クレジットカードを登録して下さい。',
                payment_failure: 'クレジットカードによる決済が失敗しました。<br/>クレジットカードの期限が過ぎた可能性があります。<br/>登録、見直しを行って下さい。',
                account_maybe_delete: '次月迄にクレジットカードを登録頂かない場合は、アカウントが削除されます。',
            },
        },
        document: {
            tutorial: 'チュートリアル(動画)',
            tutorial_v: 'チュートリアル',
            document: 'マニュアル',
            privacy_policy: 'プライバシーポリシー(PDF)',
        },
        'toogle-datepicker': '空',
        'app-setting-behaviour-tooth': '写真自動反転',
        'app-setting-behaviour-tooth-default': 'しない',
        'app-setting-behaviour-tooth-vertical': '垂直反転',
        'app-setting-behaviour-tooth-horizontal': '水平反転',
    }
}

// 'zh-tw'; : {},
// 'zh-cn'; : {},
// ko: {},
// de: {}



// WEBPACK FOOTER //
// ./src/models/language.ts